import React, { FC, useState } from 'react';

import { Button, Card, CardContent, Typography, Box, Divider, Chip } from '@mui/material';

import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import InfoIcon from '@mui/icons-material/Info';

import JobDetailsToCopyModal from './JobDetailsToCopyModal';

import { BackflowJobItem } from '../../model';

interface SubmissionPdfCardProps {
  item: BackflowJobItem;
}

const SubmissionPdfCard: FC<SubmissionPdfCardProps> = (props) => {
  const { item } = props;
  const [modalOpen, setModalOpen] = useState(false);

  const handleView = () => {
    if (item.water_authority_submission_pdf_url) {
      window.open(item.water_authority_submission_pdf_url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <Card elevation={2} sx={{ height: '100%' }}>
      <CardContent>
        <JobDetailsToCopyModal item={item} modalOpen={modalOpen} setModalOpen={setModalOpen} />
        <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
          <Typography variant="h6" fontWeight="600" color="primary">
            {item.asset_no}
          </Typography>
          <Chip label={item.status} color="success" size="small" sx={{ textTransform: 'uppercase', fontWeight: 600 }} />
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box sx={{ mb: 3 }}>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            <strong>Location:</strong>
          </Typography>
          <Typography variant="body1" gutterBottom>
            {item.location || 'N/A'}
          </Typography>

          <Typography variant="body2" color="text.secondary" gutterBottom sx={{ mt: 1 }}>
            <strong>Device Type:</strong>
          </Typography>
          <Typography variant="body1">{item.device_type || 'N/A'}</Typography>
        </Box>

        <Divider />

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mt: 2 }}>
          <Button
            variant="contained"
            color="secondary"
            startIcon={<OpenInNewIcon />}
            onClick={handleView}
            disabled={!item.water_authority_submission_pdf_url}
            fullWidth
            size="medium"
          >
            View Report
          </Button>
          <Button
            variant="outlined"
            color="primary"
            startIcon={<InfoIcon />}
            onClick={() => setModalOpen(true)}
            fullWidth
            size="medium"
          >
            View Job Details
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default SubmissionPdfCard;
